module.exports = __webpack_public_path__ + "img/logo-paloma-small@2x.6acd16c8.png";